import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const LinkButton = withStyles({
  root: {
    fontWeight: 'bold',
    width: '100%',
    maxWidth: 200,

    '&:hover': {
      color: 'white',
    },
  },
})(Button);

export default LinkButton;
